require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ens-de-lyon-informatique-et-syscom-2-5-2-6.json") })
        }
      }, "path---ens-de-lyon-informatique-et-syscom-2-5-2-6");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ens-de-lyon-informatique-et-syscom-2-5-2-6!./.cache/json/ens-de-lyon-informatique-et-syscom-2-5-2-6.json
// module id = 410
// module chunks = 231608221292675